import React, { Component } from "react";
// @material-ui/core components
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import CardFooter from "components/Card/CardFooter.js";
import Button from "components/CustomButtons/Button.js";
import CustomSelect from "components/CustomSelect/CustomSelect.js";
// services
import activityService from "services/activity.service";
// util
import Notifications from "views/Notifications/Notifications";

class AudioChoice extends Component {
    
    constructor(props) {
        super(props);
        if(this.props.activity){
            this.state = {units: this.props.unity, unity: this.props.activity.unity, selectedValue: this.props.activity.correct, title: this.props.activity.title, a: this.props.activity.alternatives[0], b: this.props.activity.alternatives[1], c: this.props.activity.alternatives[2], d: this.props.activity.alternatives[3], audio: this.props.activity.audio, notification: {show: false, message: '', type: 'info'}};
        } else {
            this.state = {units: this.props.unity, unity: '', selectedValue: -1, title: '', a: '', b: '', c: '', d: '', audio: '', notification: {show: false, message: '', type: 'info'}};
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'radio' ? parseInt(target.value) : target.type === 'file' ? target.files[0] : target.value;
        const name = target.name;

        this.setState({
            [name]: value,
        });
    };

    handleSubmit() {
        this.setState({notification: {show: true, message: 'Aguarde o envio dos arquivos!', type: 'info'}});
        if(!this.props.activity){
            const alternatives = [this.state.a, this.state.b, this.state.c, this.state.d]
            activityService.createAudioActivity({type: 'audiochoice', unity: this.state.unity, title: this.state.title, alternatives: alternatives, correct: this.state.selectedValue, audio: this.state.audio})
            .then(res => this.showNotification('Atividade cadastrada com sucesso!', 'success'))
            .catch(err => this.showNotification('Ocorreu um erro ao tentar cadastrar atividade! ' + err, 'danger'))
        } else {
            this.handleEdit();
        }
    }
    
    handleEdit() {
        const alternatives = [this.state.a, this.state.b, this.state.c, this.state.d]
        activityService.updateActivity(this.props.activity.id, {unity: this.state.unity, title: this.state.title, alternatives: alternatives, correct: this.state.selectedValue})
        .then(res => this.showNotification('Atividade atualizada com sucesso!', 'success'))
        .catch(err => this.showNotification('Ocorreu um erro ao tentar atualizar atividade! ' + err, 'danger'))
    }

    showNotification(message, type){
        if(this.state.notification.show === true) this.setState({notification: {show: false}})
        this.setState({notification: {show: true, message: message, type: type}});
        setTimeout(() => {
            this.setState({notification: {show: false, message: '', type: 'info'}});
            this.props.onClose()
        }, 3000);
    }

    render (){
        return(
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomSelect
                    labelText="Unidade" 
                    id="unity"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        type: "text",
                        name: "unity",
                        value:this.state.unity,
                        onChange:this.handleChange
                    }}
                    selectItems={this.state.units}
                    />
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                {(!this.props.activity) ?
                [<CustomInput
                    key="input"
                    labelText="Áudio"
                    id="audio"
                    formControlProps={{
                        fullWidth: true
                    }}
                    inputProps={{
                        type: "file",
                        name: "audio",
                        onChange:this.handleChange
                    }}
                />, 
                <InputLabel key="label" id="label">Áudio</InputLabel>]
                : (<InputLabel id="label" style={{'marginTop': 20}}>Áudio: {this.props.activity.audio}</InputLabel>)}
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <CustomInput 
                        labelText="Título da Atividade" 
                        id="title"
                        formControlProps={{
                            fullWidth: true
                        }}
                        inputProps={{
                            type: "text",
                            name: "title",
                            value:this.state.title,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Radio
                        checked={this.state.selectedValue === 0}
                        onChange={this.handleChange}
                        value={0}
                        name="selectedValue"
                    />
                    <CustomInput 
                        labelText="Alternativa A" 
                        id="a"
                        formControlProps={{
                            fullWidth: false
                        }}
                        inputProps={{
                            type: "text",
                            name: "a",
                            value:this.state.a,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Radio
                        checked={this.state.selectedValue === 1}
                        onChange={this.handleChange}
                        value={1}
                        name="selectedValue"
                    />
                    <CustomInput 
                        labelText="Alternativa B" 
                        id="b"
                        formControlProps={{
                            fullWidth: false
                        }}
                        inputProps={{
                            type: "text",
                            name: "b",
                            value:this.state.b,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Radio
                        checked={this.state.selectedValue === 2}
                        onChange={this.handleChange}
                        value={2}
                        name="selectedValue"
                    />
                    <CustomInput 
                        labelText="Alternativa C" 
                        id="c"
                        formControlProps={{
                            fullWidth: false
                        }}
                        inputProps={{
                            type: "text",
                            name: "c",
                            value:this.state.c,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <GridItem xs={12} sm={12} md={6}>
                    <Radio
                        checked={this.state.selectedValue === 3}
                        onChange={this.handleChange}
                        value={3}
                        name="selectedValue"
                    />
                    <CustomInput 
                        labelText="Alternativa D" 
                        id="d"
                        formControlProps={{
                            fullWidth: false
                        }}
                        inputProps={{
                            type: "text",
                            name: "d",
                            value:this.state.d,
                            onChange:this.handleChange
                        }}
                    />  
                </GridItem>
                <CardFooter>
                    <Button color="primary" type="submit" round onClick={this.handleSubmit}>{(!this.props.activity ? 'Cadastrar' : 'Editar')}</Button>
                </CardFooter>
                {(this.state.notification.show === true) ? (<Notifications notification={this.state.notification} />) : null}
            </GridContainer>
        )
    }
}

export default (AudioChoice);